import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CartMaster } from '../model/CartMaster.model';
import { CourseMaster } from '../model/CourseMaster.model';
import { StudentMaster } from '../model/StudentMaster.model';
import { AuthService } from '../service/auth.service';
import { MainserviceService } from '../service/mainservice.service';
import { MessageService } from 'primeng/api';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { FaqMaster } from '../model/FaqMaster.model';
import { TrainerMaster } from '../model/TrainerMaster.model';
import { DocumentMaster } from '../model/DocumentMaster.model';
import Player from '@vimeo/player';
import { CourseLectureMaster } from '../model/CourseLectureMaster.model';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';
declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-master-course',
  templateUrl: './master-course.component.html',
  styleUrls: ['./master-course.component.scss']
})
export class MasterCourseComponent implements OnInit {

  gallerycarousel: any;
  showVideo: boolean = false;
  tempCourse: CourseMaster[] = [];
  imagecarousel: any;
  player;
  showDialogVideo: boolean = false;
  showbracket: boolean = false;


  courseMasterTemp: CourseMaster = new CourseMaster();
  courseMaster: CourseMaster = new CourseMaster();

  documentMasterTemp: DocumentMaster = new DocumentMaster();
  documentMasterTemp1: DocumentMaster = new DocumentMaster();

  showEmi: boolean = false;
  value: boolean = false;

  faqMaster: FaqMaster = new FaqMaster();
  faqMasterList: FaqMaster[] = [];
  faqTempList: any[] = [];
  showDialogTrainer: boolean = false;
  trainerMasterTemp: TrainerMaster = new TrainerMaster();

  videoLink: any;

  showDialog1: boolean = false;
  viewRatingTemp: boolean = false;
  value1: boolean = false;
  valueTrainer: boolean = false;

  cartMaster: CartMaster = new CartMaster();

  student: StudentMaster = new StudentMaster();
  studentMaster: StudentMaster = new StudentMaster();

  constructor(private mainService: MainserviceService, private authService: AuthService, private router: Router, private messageService: MessageService
    , private sanitizer: DomSanitizer,private meta: Meta,private titleService: Title, public spinnerService: NgxSpinnerService) { 
      this.meta.updateTag({ name: 'description', content: "Ready to embark on a rewarding journey in real estate? Apply to Edstate and access our acclaimed Real Estate Mastery Program." });
      titleService.setTitle("Edstate | Real Estate Mastery Program");
    }

  ngOnInit() {
    this.spinnerService.show()
    this.student = this.authService.getUserSession();
    this.getFaqList();

    this.gallerycarousel = {
      loop: false,
      autoplay: false,
      margin: 20,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      items: 4,
      navSpeed: 1000,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 2
        },
        740: {
          items: 3
        },
        940: {
          items: 4
        }


      },
      nav: true
    }

    this.imagecarousel = {
      loop: false,
      autoplay: false,
      margin: 1000,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      items: 1,
      navSpeed: 500,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 2
        },
        740: {
          items: 3
        },
        940: {
          items: 4
        }


      },
      nav: true
    }








    this.getCourseMasterById();
    
  }


  getCourseMasterById() {

    // this.courseMasterTemp.courseMasterId= 1;
    if(this.student != null &&  this.student.studentMasterId != null){
      this.courseMasterTemp.studentMasterId = this.student.studentMasterId;
    }
    this.mainService.getMasterCourse(this.courseMasterTemp).subscribe(data => {
      this.courseMaster = data;
      this.spinnerService.hide()
      this.showbracket = true;

    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        this.showbracket = true;
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        // this.packageServiceList = JSON.parse(jsonString);

      }


    })


  }

  navigateCourse() {
    this.router.navigateByUrl('/courses')
  }


  downloadFile(fileUrl: string) {

    if (fileUrl === null) {
      this.messageService.add({ severity: 'error', summary: 'No Brochure', detail: 'available' });
      return;
    }

    var fileUrlSplit = fileUrl.split("/");

    FileSaver.saveAs(fileUrl, fileUrlSplit[fileUrlSplit.length - 1]);

  }


  downloadBrochure(courseMaster: CourseMaster) {

    if (courseMaster.courseBrochure.filePath != null) {
      this.downloadFile(courseMaster.courseBrochure.filePath);
    } else {
      this.messageService.add({ severity: 'error', summary: 'No Brochure', detail: 'available' });
    }
  }


  buyCourse() {
    this.courseMaster.courseLectureMasterList = [];
    this.tempCourse.push(this.courseMaster);
    this.authService.setcourseListSession(this.tempCourse);



    this.router.navigateByUrl('/payment-confirmation');
  }

  resumeCourse(){

    let enrollCourseMasterTemp = new EnrollCourseMaster();
    enrollCourseMasterTemp.enrollCourseMasterId = this.courseMaster.enrollCourseMasterId;
    this.authService.setEnrollCourseMasterSession(enrollCourseMasterTemp);
    this.router.navigateByUrl('/mycourse-details');

  }

  viewEmi() {


    this.showEmi = true;


  }

  navigateTrainer(trainerMaster: TrainerMaster) {
    this.authService.setTrainerSession(trainerMaster);
    this.router.navigateByUrl('/trainer-profile')
  }

  viewDialogVideo(courseLecture: CourseLectureMaster) {
    this.documentMasterTemp1 = courseLecture.lectureMaster.demoVideo;
    if (this.documentMasterTemp1.linkId != null && this.documentMasterTemp1.linkId != undefined) {
      this.documentMasterTemp1.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentMasterTemp1.link);
    }
    this.showDialogVideo = true;

    setTimeout(() => {
      this.initPlayer1();
      this.setVideo1(this.documentMasterTemp1.linkId);

      this.playVideo1();

    }, 500);
  }

  public initPlayer1() {
    this.player = new Player('video_iframe', {});
    // this.updateVideoCompleted();
  }

  setVideo1(videoId: any) {

    this.player.loadVideo(videoId).then(function (id) {

    });

  }

  playVideo1() {
    setTimeout(() => {
      this.player.play().then(function () {

      });
    }, 1000);

  }





  closeVideo() {
    this.showDialogVideo = false;
  }


  closeBannerVideo() {
    this.showVideo = false;
  }




  getFaqList() {

    this.mainService.getFaqList(this.faqMaster).subscribe(
      (data) => {
        this.faqMasterList = data;


      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }


  pleaseLogin() {
    this.messageService.add({ severity: 'error', summary: 'Please Login', detail: 'to continue' });
  }



  viewDialog() {


    this.showDialog1 = true;


  }

  viewDialogTrainer(trainerMaster: TrainerMaster) {
    this.trainerMasterTemp = new TrainerMaster()
    this.trainerMasterTemp = trainerMaster;
    this.showDialogTrainer = true;

  }

  viewRating() {


    this.viewRatingTemp = false;

  }


  videoDisplay() {


    this.documentMasterTemp = this.courseMaster.courseBannerVideo;
    if (this.documentMasterTemp.linkId != null && this.documentMasterTemp.linkId != undefined) {
      this.documentMasterTemp.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentMasterTemp.link);
    }

    this.showVideo = true;


    setTimeout(() => {
      this.initPlayer();
      this.setVideo(this.documentMasterTemp.linkId);

      this.playVideo();

    }, 500);


  }

  public initPlayer() {
    this.player = new Player('video_iframe', {});
    // this.updateVideoCompleted();
  }

  setVideo(videoId: any) {

    this.player.loadVideo(videoId).then(function (id) {

    });

  }

  playVideo() {
    setTimeout(() => {
      this.player.play().then(function () {

      });
    }, 1000);

  }



}
